import "./ProductsMenegment.scss";

const ProductsMenegment = () => {
  return <div className="products">ProductsMenegment</div>;
};

export default ProductsMenegment;
